export default "__VITE_ASSET__CVeXbfQI__"